import constants from "./constant";
import GatewayGet from "./GatewayGet";

//Services for FF Rates Screen

let props = {};
let inputObj = {};
let InputJSONString = "";
props["query"] = constants.serviceRoot;
props["headers"] = constants.serviceHeaders;

export const LoadStatusData = async () => {

    InputJSONString ="";
    inputObj["Activity"] = "F4_DOCSTATUS_DROPDWN";
    inputObj["Input"] = InputJSONString;
    props.input = inputObj;
    const result = await GatewayGet(props, props.input);
    return result;
  };


//ISR start 
export const commonFoCreateUpdate = async(activityname,inputData) => {

   if(activityname=="FO_HEADER_CREATE_SB")
   inputObj["Activity"]=activityname;
   else if(activityname=="FG_FO_HEADER_UPDATE")
   inputObj["Activity"]=activityname;
   else if(activityname=="FO_HEADER_CREATE_MB")
   inputObj["Activity"]=activityname;
   else if(activityname=="FO_HEADER_UPDATE_MB")
   inputObj["Activity"]=activityname;

        InputJSONString =JSON.stringify(inputData);      
        inputObj["Activity"] = activityname;
        inputObj["Input"] = InputJSONString;
        props.input = inputObj;
        const result = await GatewayGet(props, props.input);
        return result;
}
//this will work for all order types
  export const ProductDeleteItemCall = async (input) => {
    InputJSONString =JSON.stringify(input);
    inputObj["Activity"] = "FO_ITEM_DELETE_SB";
    inputObj["Input"] = InputJSONString;
    props.input = inputObj;
    const result = await GatewayGet(props, props.input);
    return result;
  };

export const CreateProductItem = async (input,torType) => {
  let InputJSONString=JSON.stringify(input);
  if(torType == "ZMSB")
  inputObj["Activity"] = "FO_ITEM_CREATE_PRODUCT_MB";
  else
  inputObj["Activity"] = "FO_ITEM_CREATE_PRODUCT_SB";
  inputObj["Input"] =InputJSONString;
  props.input = inputObj;
  const result = await GatewayGet(props, props.input);
    return result;
};

export const CreateItemPackage = async (input,torTpe) => {
let InputJSONString=JSON.stringify(input);
if(torTpe == "ZMSB")
inputObj["Activity"] = "FO_ITEM_CREATE_MB";
else
inputObj["Activity"] = "FO_ITEM_CREATE_SB";

inputObj["Input"] =InputJSONString;
props.input = inputObj;
const result = await GatewayGet(props, props.input);
return result;
}

export const PackageUpdateItem = async (input,torTpe) => {
  let InputJSONString=JSON.stringify(input);
  if(torTpe == "ZMSB")
  inputObj["Activity"] = "FO_ITEM_UPDATE_MB";
  else
  inputObj["Activity"] = "FO_ITEM_UPDATE_SB";
  inputObj["Input"] =InputJSONString;
  props.input = inputObj;
  const result = await GatewayGet(props, props.input);
  return result;
};

export const PackageDisplay = async (input,tor_Type) => {

  let InputJSONString=JSON.stringify(input);
  if(tor_Type == "ZSSB")
  inputObj["Activity"] = "FO_DISPLAY_SB";
  else if(tor_Type == "ZEXC")
  inputObj["Activity"] = "FO_DISPLAY_INVA";
  else
  inputObj["Activity"] = "FO_DISPLAY_MB";
  inputObj["Input"] =InputJSONString;
  props.input = inputObj;
  const result = await GatewayGet(props, props.input);  
  return result;
}

  /*************NCRM**************************** */

  export const FO_CANCEL_DATA =async (input)=>{
    let inputJsonString=JSON.stringify(input);
    inputObj["Activity"]="FO_CANCEL";
    inputObj["Input"]=inputJsonString;
    props.input=inputObj;
    const result=await GatewayGet(props,props.input);
    return result;

  }

  export const StopTendering =async (input)=>{
    let inputJsonString=JSON.stringify(input);
    inputObj["Activity"]="FO_STOP_TENDERING";
    inputObj["Input"]=inputJsonString;
    props.input=inputObj;
    const result=await GatewayGet(props,props.input);
    return result;
  }

  export const FO_WORKLIST_SEARCH = async (input) => {

//    InputJSONString =JSON.stringify(input);
    inputObj["Activity"] = "FO_WORKLIST_SEARCH";
    inputObj["Input"] = InputJSONString;
    props.input = inputObj;
    const result = await GatewayGet(props, props.input);
    return result;
  };



